import { createRouter, createWebHistory } from "vue-router";
import Users from "@/views/Users/index.vue";
import UsersCreate from "@/views/Users/create.vue";
import UsersDetail from "@/views/Users/detail.vue";
import Staff from "@/views/Staff/index.vue";
import StaffCreate from "@/views/Staff/create.vue";
import StaffDetail from "@/views/Staff/detail.vue";
import Notifications from "@/views/Notifications/index.vue";
import AuditLogs from "../views/AuditLogs/index.vue";
import Login from "@/views/SignIn.vue";
import authGuard from "@/router/authGuard";

const STAFF_AND_ADMIN = ["administrator", "supervisor", "agent"];

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/login",
    meta: {
      auth: false,
      roles: ["administrator"],
    },
  },
  {
    path: "/users",
    name: "users",
    meta: {
      auth: true,
      roles: STAFF_AND_ADMIN,
    },
    component: Users,
  },
  {
    path: "/users-create",
    name: "users-create",
    meta: {
      auth: true,
      roles: STAFF_AND_ADMIN,
    },
    component: UsersCreate,
  },
  {
    path: "/users-view",
    name: "users-view",
    meta: {
      auth: true,
      roles: STAFF_AND_ADMIN
    },
    component: UsersDetail
  },
  {
    path: "/staff",
    name: "staff",
    meta: {
      auth: true,
      roles: ["administrator"]
    },
    component: Staff
  },
  {
    path: "/staff-create",
    name: "staff-create",
    meta: {
      auth: true,
      roles: ["administrator"]
    },
    component: StaffCreate
  },
  {
    path: "/staff-view",
    name: "staff-view",
    meta: {
      auth: true,
      roles: ["administrator"]
    },
    component: StaffDetail
  },
  {
    path: "/notifications",
    name: "notifications",
    meta: {
      auth: true,
      roles: ['administrator']
    },
    component: Notifications
  },

  {
    path: "/audit-logs",
    name: "audit-logs",
    meta: { auth: true, roles: ["administrator"] },
    component: AuditLogs,
  },
  {
    path: "/login",
    name: "login",
    meta: {
      auth: false,
      roles: ["administrator"],
    },
    component: Login,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});
router.beforeEach(authGuard);
export default router;
